import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RotateCcw, Package } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/ui-helpers";

const RELEVANT = ["cancelled", "return_requested", "return_approved", "pickup_scheduled", "inspection", "returned", "refunded"];

export default function ReturnsPage() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/marketplace/my-orders").then((r) => {
      const all = r.data.orders || [];
      setItems(all.filter((o) => RELEVANT.includes(o.status) || o.refund_status));
    }).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="returns-page">
      <PageHeader title="Returns & Refunds" icon={RotateCcw} subtitle="Track your cancellations, returns and refunds with their full status history." />
      {items && items.length === 0 && (
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center" data-testid="returns-empty">
          <RotateCcw className="mx-auto h-8 w-8 text-slate-300" />
          <p className="mt-3 font-semibold text-slate-700">No pending returns or refunds</p>
          <button onClick={() => nav("/app/shop-orders")} className="mt-3 rounded-full border border-slate-200 px-4 py-2 text-sm font-medium text-slate-600">View your orders</button>
        </div>
      )}
      <div className="space-y-3" data-testid="returns-list">
        {(items || []).map((o) => (
          <div key={o.suborder_id || o.number} className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`return-${o.suborder_id || o.number}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2"><Package className="h-4 w-4 text-slate-400" /><p className="text-sm font-semibold text-slate-800">Order {o.number}</p></div>
              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-medium capitalize text-slate-500">{(o.status || "").replace(/_/g, " ")}</span>
            </div>
            {o.refund_status && <p className="mt-1 text-xs font-medium text-blue-600">Refund: {o.refund_status.replace(/_/g, " ")}{o.refund_status === "refunded" ? " ✓" : ""}</p>}
            <ol className="mt-3 space-y-2 border-l-2 border-slate-100 pl-4" data-testid="return-timeline">
              {(o.history || []).map((h, i) => (
                <li key={i} className="relative">
                  <span className="absolute -left-[21px] top-1 h-2.5 w-2.5 rounded-full bg-blue-400" />
                  <p className="text-sm capitalize text-slate-700">{(h.status || "").replace(/_/g, " ")}</p>
                  <p className="text-xs text-slate-400">{h.at ? new Date(h.at).toLocaleString() : ""}{h.by ? ` · ${h.by}` : ""}</p>
                </li>
              ))}
              {(!o.history || o.history.length === 0) && <li className="text-sm text-slate-400">No status history recorded yet.</li>}
            </ol>
          </div>
        ))}
      </div>
    </div>
  );
}
